import React, {Suspense} from 'react';
import PropTypes from 'prop-types';
import ArticleBlock from '../../adapters/helpers/ArticleBlock';
import dynamic from 'next/dynamic';
const BiographyContent = dynamic(() => import('../BiographyContent/BiographyContent'));
import Loader from '../../adapters/helpers/Loader'
import { LazyLoadComponent } from 'react-lazy-load-image-component';

export default function ArticleBody(props) {
    const extraAttributes = props.extraAttributes || {};
    const article = extraAttributes.entity;

    const articleBlock = new ArticleBlock({document: props.document, article });

    const children = articleBlock.renderChildBlocks({ extraAttributes }, props.onClickCallback, props.customEvent);
    const biographyContent = articleBlock?.article?.biographyContent?.fields || null;
    const biographyModalArticleList = articleBlock?.article?.articleListsForBiographyModal || null;

    return (
        <div className='ob-article-body'>
             <LazyLoadComponent offset={100}>
            <Suspense fallback={<Loader />}>
            {children}
            </Suspense>
            <React.Fragment>
            <Suspense fallback={<Loader />}>
                {biographyContent && <BiographyContent biographyContent={biographyContent} 
                biographyModalArticleList={biographyModalArticleList} />}
            </Suspense>
            </React.Fragment>
            </LazyLoadComponent>
        </div>
    );
}

ArticleBody.propTypes = {
    className: PropTypes.string,
    extraAttributes: PropTypes.object,
    document: PropTypes.object,
    onClickCallback:  PropTypes.func,
    customEvent: PropTypes.object
};
